import { TUserRole } from 'types/state';
import { M8UserRole } from 'services/production/types';
import { UnreachableError } from 'utils/errors';

export const normalizeM8RoleName = (roleName: M8UserRole) => ({
  toUserRole(): TUserRole {
    switch (roleName) {
      case 'ROLE_ADMIN':
        return 'ADMIN';
      case 'ROLE_USER':
        return 'CLIENT';
      case 'ROLE_PRE_PARTNER':
        return 'PARTNER_CANDIDATE';
      case 'ROLE_PARTNER':
        return 'PARTNER';
      case 'ROLE_PROMO':
        return 'PROMO';
      default:
        throw new UnreachableError(roleName);
    }
  },
});
